const Functions = {
  changeQuantity(line, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity: quantity, line: line }),
    })
      .then((response) => response.json())
      .then((data) => {
        window.dispatchEvent(new CustomEvent("update-cart", { detail: data }));
      })
      .catch((errror) => console.error("Error:", error));
  },
  addToCart(form) {
    let formData = new FormData(form);
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        window.dispatchEvent(new CustomEvent("update-cart"));
        window.dispatchEvent(new CustomEvent("toggle-cart"));
        document.body.classList.add("overflow-hidden");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
};

window.Functions = Functions;

function initVariantSelects() {
  document
    .querySelectorAll(".collection-tabs__variants-select")
    .forEach(function (selectEl) {
      selectEl.addEventListener("change", function () {
        const selectedOption = selectEl.options[selectEl.selectedIndex];
        const price = selectedOption.getAttribute("variant-price");
        const compareAt = selectedOption.getAttribute("variant-sale");
        const variantId = selectedOption.getAttribute("variant-id");

        const card = selectEl.closest(".featured-products__card");
        const wrapper = document.querySelector('.collection__product-grid');
        const sectionSettings = {
          add_to_cart: wrapper?.dataset.addToCart || 'In den Warenkorb',
          add_to_cart_disabled: wrapper?.dataset.addToCartDisabled || 'Nicht verfügbar',
        };

        const priceEl = card.querySelector(".product-price");
        const comparePriceEl = card.querySelector(".product-compare-price");
        const variantIdInput = card.querySelector(".variant-id-input");

        const isAvailable = selectedOption.getAttribute('variant-available') === 'true';
        const addToCartButton = card.querySelector('.collection-add-to-cart-button');

        if (addToCartButton) {
          addToCartButton.disabled = !isAvailable;
          addToCartButton.textContent = isAvailable
            ? sectionSettings.add_to_cart
            : sectionSettings.add_to_cart_disabled;

          addToCartButton.classList.toggle('collection-add-to-cart-button-disabled', !isAvailable);
        }

        if (priceEl) priceEl.textContent = price;

        if (comparePriceEl) {
          if (compareAt && compareAt.trim() !== "" && compareAt.length > 1) {
            comparePriceEl.textContent = compareAt;
            comparePriceEl.classList.remove("hidden");
          } else {
            comparePriceEl.textContent = "";
            comparePriceEl.classList.add("hidden");
          }
        }

        if (variantIdInput) {
          variantIdInput.value = variantId;
        }
      });
    });
}

document.addEventListener("DOMContentLoaded", function () {
  initVariantSelects();
});
